
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Flexstar-LINEAR-TOP-LIGHT-SERIES",
      function () {
        return require("private-next-pages/Flexstar-LINEAR-TOP-LIGHT-SERIES.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Flexstar-LINEAR-TOP-LIGHT-SERIES"])
      });
    }
  